
import * as types from './mutation-types'


export const loadNotices = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/modules/notices').then((response) => {
            commit(types.LOAD_NOTICES, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const receiveNotice = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('receive/notice', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


